import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getVersions = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`version/data?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// تغيير الدالة لتتقبل payload واحد (مثال: { plane_id: 11, type: "request_plane", message: "..." })
export const makeSupportRequestForVersion = (payload) => {
  const token = localStorage.getItem("authToken");
  return api.post(
    `make/support/request?api_password=${API_PASSWORD}`,
    payload,
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    }
  );
};

// للحفاظ على التوافق مع أي استدعالات قديمة (اختياري)
export const makeSupportRequestForVersionLegacy = (plane_id, type, message) =>
  makeSupportRequestForVersion({ plane_id, type, message });

// إضافة دالة جلب كل طلبات الدعم (للمشرف)
export const getAllSupportRequests = () => {
  const token = localStorage.getItem("authToken");
  return api.get(`get/all/support/request?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

/**
 * تعليم طلب دعم كمقروء (للمشرف)
 * يتوقع أن يكون endpoint على الشكل: make/support/request/seen/{id}?api_password=...
 */
export const markSupportRequestSeen = (requestId) => {
  const token = localStorage.getItem("authToken");
  if (!requestId) return Promise.reject(new Error("requestId is required"));
  return api.get(`make/support/request/seen/${requestId}?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};



